import React, { useState } from "react";
import { func, number, oneOf } from "prop-types";

import getCurrentUser from "src/features/authentication/src/helpers/getCurrentUser";
import GlobalState from "src/shared/utilities/globalState";

import NoteEditor from "../NoteEditor";
import * as S from "./styled";

const AddNote = props => {
  const [isEditorOpened, setIsEditorOpened] = useState(false);

  const isUserLoggedIn = async callback => {
    const viewerInfo = await getCurrentUser();

    return callback(!!viewerInfo);
  };

  const handleClick = () => {
    isUserLoggedIn(loggedIn => {
      if (loggedIn) {
        setIsEditorOpened(true);
      } else {
        const triggerScenario = GlobalState.get("triggerScenario");
        if (typeof triggerScenario === "function") {
          GlobalState.get("callbacks").accountCreated = undefined;
          GlobalState.get("callbacks").login = undefined;

          GlobalState.registerCallback("accountCreated", () =>
            window.location.reload()
          );
          GlobalState.registerCallback("login", () => window.location.reload());

          triggerScenario("");
        }
      }
    });
  };

  return (
    <S.Container>
      {isEditorOpened ? (
        <>
          <S.Header as="label" id="listing-note-text">
            Your Notes
          </S.Header>
          <NoteEditor
            closeEditor={() => setIsEditorOpened(false)}
            type="create"
            {...props}
          />
        </>
      ) : (
        <S.AddButton onClick={handleClick}>
          <S.AddIcon />
          Add notes to this listing
        </S.AddButton>
      )}
    </S.Container>
  );
};

AddNote.propTypes = {
  listing_id: number.isRequired,
  listing_type: oneOf(["sale", "rental"]).isRequired,
  setNoteText: func.isRequired
};

export default AddNote;
